import React from 'react';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


const WomenBanner = props => {
  const { pagedetails = {}, componentTitle } = props;
  const { banner = { imageUrl: '' } } = pagedetails;
  const widgetType = pagedetails.typeCode;
  const sectionName = componentTitle || pagedetails.typeCode;
  let bannerImgUrl = '';
  bannerImgUrl =
    banner.imageUrl.indexOf('?') == -1
      ? banner.imageUrl
      : banner.imageUrl.substr(0, banner.imageUrl.indexOf('?'));
  if (banner === undefined) {
    return null;
  }
  const redirectUrl =
    banner.absoluteUrl && banner.page === 'storelandingpage'
      ? banner.absoluteUrl
      : banner.bannerUrlLink;
  const openInNewTab = banner.openInNewTab ? '_blank' : '_self';

  return (
    <a
      href={redirectUrl}
      target={openInNewTab}
      className="img-animate"
      data-ga-event-category="bannerTap"
      data-ga-event-action={`${sectionName}/${banner.componentPosition}/${widgetType}`}
      data-ga-event-label={`${bannerImgUrl}/${banner.bannerPosition}`}
      data-gtm-bnr-position={`${banner.componentPosition}`}
      data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(banner.imageUrl) || ''}`}
      data-gtm-bnr-id={`${banner.uId || ''}`}
    >
      <img src={`${replaceWithJioCDN(banner.imageUrl)}`} />
    </a>
  );
};

export default BannerWrapper(WomenBanner);
